import { jsx as _jsx } from "react/jsx-runtime";
import { FilterItem, FilterItemType, Text, TextSize } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { BUCKET_FILTER, MULTISELECT_FILTER, LINK_FILTER, } from '@as-react/common-types';
import { FILTER_SIZE_SEPARATOR } from '../../../constants/GeneralConstants';
export const FilterSizeItem = ({ item, type, filter, toggleFilterValue, desktop, search, }) => {
    const { pageInfo, canonicalUrl } = useAemConfig();
    const isBrandFilter = filter.filterOn === 'brand' && (pageInfo.isBrandPage || pageInfo.isCategoryPage);
    const baseUrl = canonicalUrl.slice(0, canonicalUrl.indexOf('.html'));
    const filterName = item.name.split(FILTER_SIZE_SEPARATOR)[0];
    let url = '';
    let filterItemType;
    switch (type) {
        case BUCKET_FILTER:
            filterItemType = FilterItemType.SINGLE;
            break;
        case LINK_FILTER:
            filterItemType = FilterItemType.LINK;
            break;
        case MULTISELECT_FILTER:
        default:
            filterItemType = FilterItemType.MULTI;
    }
    if (isBrandFilter && !!item.normalizedName) {
        url = `${baseUrl}/${item.normalizedName}.html`;
    }
    else if (type === LINK_FILTER) {
        const urlObj = new URL(canonicalUrl);
        urlObj.searchParams.set(filter.queryParamKey, `${filter.filterOn}:${item.filterKey}`);
        url = urlObj.toString();
    }
    return (_jsx(FilterItem, { type: filterItemType, filterOn: desktop ? `${filter.filterOn}-desktop` : filter.filterOn, filterKey: item.filterKey, linkTitle: filterName, text: search ? (_jsx(Text, { inline: true, size: TextSize.INHERIT, html: filterName.replace(new RegExp(`(${search})`, 'i'), '<strong>$1</strong>') })) : (filterName), normalizedName: item.normalizedName, itemCount: item.itemCount, active: item.active, onChange: (e) => toggleFilterValue(e, item), onClick: e => toggleFilterValue(e, item), url: url }, item.filterKey));
};
